/**
 * BSF Price Animator - Temu-style number shuffle animation
 * ~700 bytes minified | No dependencies | 60fps animations
 */
class BsfPriceAnimator {
  animate(el, oldValue, newValue) {
    if (!el || oldValue === newValue) return;

    // Preserve original spacing - only trim ends
    const oldStr = (oldValue || '').trim();
    const newStr = (newValue || '').trim();
    if (oldStr === newStr) return;

    // Build animated HTML with random up/down directions
    let html = '';

    for (let i = 0; i < newStr.length; i++) {
      const newChar = newStr[i];
      const oldChar = oldStr[i] || '';
      const isDigit = /\d/.test(newChar);
      const isSpace = /\s/.test(newChar);
      const changed = newChar !== oldChar;

      if (isDigit && changed) {
        // Random direction: up or down
        const dir = Math.random() > 0.5 ? 'up' : 'down';
        html += `<span class="bsf-price-digit bsf-price-digit--${dir}">${newChar}</span>`;
      } else if (isDigit) {
        html += `<span class="bsf-price-digit">${newChar}</span>`;
      } else if (isSpace) {
        // Preserve spaces with non-breaking space entity
        html += '&nbsp;';
      } else {
        html += newChar;
      }
    }

    // Wrap in container and update (inline to preserve text flow)
    el.innerHTML = `<span class="bsf-price-animated">${html}</span>`;

    // Clean up after animation
    const digits = el.querySelectorAll('.bsf-price-digit--up, .bsf-price-digit--down');
    if (digits.length > 0) {
      const lastDigit = digits[digits.length - 1];
      lastDigit.addEventListener('animationend', () => {
        // Restore original text without spans
        el.textContent = newStr;
      }, { once: true });
    } else {
      // No animated digits, restore immediately
      el.textContent = newStr;
    }
  }
}

window.BsfPriceAnimator = new BsfPriceAnimator();
